import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bell",
  "use": "icon-bell-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-bell\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h32v32H0z\" /><path d=\"M29.333 26.667H2.667V24H4v-9.292C4 8.058 9.373 2.667 16 2.667s12 5.39 12 12.041V24h1.333v2.667ZM12.667 28h6.666a3.333 3.333 0 1 1-6.666 0Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol